import { z } from 'zod';
export const ptSummaryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        summary: z.object({
            disciplinesStilProvidingCare: z.array(z.string()).optional(),
            initialReasonHomeTherapy: z.string().optional(),
            reasonStillHomebound: z.string().optional(),
            impairmentsStillAddressed: z.array(z.string()).optional(),
            impairmentsStillAddressedOther: z.string().optional(),
        }),
        impairmentSummary: z.object({
            initial: z.string().optional(),
            current: z.string().optional(),
            goal: z.string().optional(),
        }),
        functionalSummary: z.object({
            initial: z.string().optional(),
            current: z.string().optional(),
            goal: z.string().optional(),
        }),
        outcomeMeasures: z.object({
            measure: z.array(z.string()).optional(),
            measureOther: z.string().optional(),
            initial: z.string().optional(),
            current: z.string().optional(),
            goal: z.string().optional(),
        }),
        selfCare: z.object({
            grooming: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            toileting: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            bathing: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            dressingUE: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            dressingLE: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            socks: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
        }),
        mobility: z.object({
            indoor: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            outdoor: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            stepCurb: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
        }),
        transfers: z.object({
            bed: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            sitStand: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            toilet: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            chair: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            floor: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            shower: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            car: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
        }),
        functional: z.object({
            mealPrep: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
            houseChores: z
                .object({
                goal: z.string().optional(),
                eval: z.string().optional(),
                clof: z.string().optional(),
            })
                .optional(),
        }),
        requestExtension: z.object({
            barriers: z.string().optional(),
            reasonContinueSN: z.string().optional(),
            seeNewPOC: z.boolean().optional(),
            newPOC: z.string().optional(),
        }),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
